import axios from 'axios';
import { SYSTEM_OVERVIEW_ENDPOINT } from '../constants/endpoint';

export default async () => axios.post(`${SYSTEM_OVERVIEW_ENDPOINT}`);
